import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import * as z from "zod";
import { zodValidator } from "@tanstack/zod-adapter";
import { ScheduledMeetingsPage } from "./-components/ScheduledMeetingsPage";
import { PLATFORM_OPTIONS } from "./-components/meetings-utils";
import { meetingsListQueryOptions } from "@/lib/queries/meetings";

const searchSchema = z.object({
  page: z.number().int().positive().default(1).catch(1),
  per_page: z.number().int().positive().max(100).default(10),
  search: z.string().optional(),
  date_filter: z.enum(["all", "today", "week", "month", "custom"]).optional(),
  date_from: z.string().optional(),
  date_to: z.string().optional(),
  platform: z.array(z.enum(PLATFORM_OPTIONS)).default(["All"]).catch(["All"]),
  scope: z.enum(["own", "organization"]).optional(),
});

export const Route = createFileRoute("/_app/meetings/scheduled")({
  component: ScheduledMeetingsPage,
  validateSearch: zodValidator(searchSchema),
  search: {
    middlewares: [
      stripSearchParams({
        search: "",
        platform: ["All"],
      }),
    ],
  },
  loaderDeps: ({ search }) => search,
  loader({ context: { queryClient }, deps }) {
    queryClient.ensureQueryData(
      meetingsListQueryOptions({
        ...deps,
        search: deps.search ?? "",
        date_direction: "future",
        state_group: ["SCHEDULED"],
        platform:
          deps.platform.length > 0 && !deps.platform.includes("All")
            ? deps.platform
            : undefined,
      }),
    );
  },
});
